const topics = [
  { name: '顶流恋情', heat: '238.6w', trend: 'up', icon: 'ri-fire-line' },
  { name: '综艺翻车', heat: '187.2w', trend: 'up', icon: 'ri-fire-line' },
  { name: '古装剧换角', heat: '165.8w', trend: 'up', icon: 'ri-fire-line' },
  { name: '明星直播', heat: '142.3w', trend: 'up', icon: 'ri-fire-line' },
  { name: '新剧定档', heat: '128.9w', trend: 'up', icon: 'ri-arrow-up-line' },
  { name: '音乐抄袭', heat: '116.5w', trend: 'up', icon: 'ri-arrow-up-line' },
  { name: '杀青冲突', heat: '98.7w', trend: 'hot', icon: 'ri-fire-line' },
  { name: '代言解约', heat: '87.4w', trend: 'new', icon: 'ri-sparkling-line' },
  { name: '番位之争', heat: '76.2w', trend: 'new', icon: 'ri-sparkling-line' },
  { name: '生日应援', heat: '65.8w', trend: 'new', icon: 'ri-sparkling-line' },
  { name: '跨年晚会', heat: '58.3w', trend: 'stable', icon: 'ri-more-line' },
];

export default function TopicsSection() {
  const trendStyles: Record<string, string> = {
    up: 'bg-primary-50 text-primary-600',
    hot: 'bg-accent-50 text-accent-600',
    new: 'bg-secondary-50 text-secondary-700',
    stable: 'bg-background-200 text-foreground-500',
  };

  const trendLabels: Record<string, string> = {
    up: '飙升',
    hot: '爆火',
    new: '新晋',
    stable: '持续',
  };

  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            热门话题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">当前最火的十一个吃瓜话题标签</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
          {topics.map((item, idx) => (
            <div
              key={idx}
              className="flex items-center gap-3 bg-background-50 rounded-full px-4 py-2.5 cursor-pointer transition-all duration-300 hover:-translate-y-0.5 hover:bg-background-50"
            >
              <span className="text-xs font-bold text-foreground-400 whitespace-nowrap">#{idx + 1}</span>
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{item.name}</span>
              <span className="text-xs text-foreground-500 whitespace-nowrap">{item.heat}</span>
              <span className={`text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap ${trendStyles[item.trend]}`}>
                {trendLabels[item.trend]}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}